import PopupOpenConfigStorage from '../../constants/PopupOpenConfigStorage';
import { PopupIds } from '../../constants/PopupIds';
import { GameClient } from '../../gameClient/gameClient';
import { createIframe } from '../../utils/window';
import { PollFinishedCommand } from '../../gameClient/clientCommands/pollFinishedCommand';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function openPoll(params:any) {
    const popupOpenParams = PopupOpenConfigStorage.getPopupOpenConfig(PopupIds.POLLING_WINDOW);
    GameClient.hide();
    clearWindow();

    const linkData = params.params;
    let pollFrame;


    if (isJson(linkData)) {
        const clientData = JSON.parse(linkData);
        let pollUrl = clientData[window.app.config.locale] ?? clientData.en_US;


        if (clientData.base_link) {
            pollUrl = clientData.base_link;
        }

        window.pollFinish = pollFinish;
        pollFrame = createIframe(pollUrl, 860, 650, false);
    } else {
        pollFrame = createIframe(linkData, 860, 650, false);
    }


    $('#polling_window_popup .popup_body').append(pollFrame);
    window.app.popup(popupOpenParams);
    $('body').on('click', '#polling_window_popup .close_button', ()=>{ window.app.game_popup_close(); });
}


async function pollFinish() {
    const cmd = new PollFinishedCommand({});
    await GameClient.getInstance().sendCommand<void>(cmd);
    window.app.game_popup_close();
}

function clearWindow() {
    $('#polling_window_popup .popup_body > *').remove();
}


function isJson(str:string) {
    try {
        JSON.parse(str);
    } catch (error) {
        return false;
    }
    return true;
}
